"use client";

import React from "react";
import { Car, HeartHandshake, MapPin } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const advantages = [{
  title: "Ample & Secure Parking",
  icon: Car,
  content: "Unlike many venues in central Bali, we offer extensive parking facilities right in Peliatan. This crucial advantage ensures stress-free arrivals for all your guests, whether they are attending a large wedding dinner or a corporate retreat."
}, {
  title: "Prime Peliatan Location",
  icon: MapPin,
  content: "Nestled in the heart of Peliatan, Ubud, our venue combines easy accessibility with breathtaking, scenic rice field surroundings. It is the perfect balance of convenience and natural Balinese beauty for your intimate or medium-sized gatherings."
}, {
  title: "Warm Filipino Hospitality",
  icon: HeartHandshake,
  content: "Experience our signature warm Filipino hospitality. We offer flexible food and catering packages, including set menus and buffets, to ensure your event feels personal, welcoming, and perfectly tailored to your specific needs."
}];
export default function TheUbudAdvantage() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-ubud-advantage" className="bg-background py-16 md:py-24 overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative h-[450px] sm:h-[550px] lg:h-[650px] w-full max-w-2xl mx-auto lg:mx-0">
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/ubud_scenic_rice_field_view.png" alt="Scenic rice fields surrounding Ubud Event Space" className="absolute top-0 left-0 w-[75%] h-[65%] object-cover rounded-2xl shadow-lg" />
            
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/ubud_ample_parking_area.png" alt="Ample parking space in Peliatan" className="absolute bottom-[5%] left-[5%] w-[45%] h-[40%] object-cover rounded-2xl shadow-xl border-4 border-background z-10" />
            
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/ubud_warm_hospitality_staff.png" alt="Warm Filipino hospitality staff" className="absolute top-[20%] right-0 w-[55%] h-[55%] object-cover rounded-2xl shadow-2xl border-4 border-background z-20" />
            
            {}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-primary/5 rounded-full blur-3xl -z-10"></div>
            <div className="absolute -top-6 -left-6 w-40 h-40 bg-secondary/10 rounded-full blur-3xl -z-10"></div>
          </div>

          {}
          <div className="flex flex-col space-y-8">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground tracking-tight">
                The Ubud Advantage
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed max-w-xl">
                Discover why UBUD EVENT SPACE is the go-to destination for private dining, weddings, and workshops. We blend modern elegance with nature-inspired design.
              </p>
            </div>

            <Accordion type="single" collapsible className="w-full max-w-xl">
              {advantages.map((adv, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
                  <AccordionTrigger className="text-lg font-semibold text-foreground hover:text-primary py-5">
                    <div className="flex items-center gap-4">
                      <div className="flex items-center justify-center size-10 rounded-full bg-primary/10 text-primary shrink-0">
                        <adv.icon className="size-5" />
                      </div>
                      <span className="text-left">{adv.title}</span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed text-base pb-6 pl-14">
                    {adv.content}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}